import { color } from "lib/theme/color";
import { size } from "lib/theme/size";
import theme from "lib/theme/theme";
import { SxObjType } from "lib/theme/types/SxObjType.type";

const sxStyles = () => {
  return {
    card: {
      boxShadow: "0px 0px 6px " + color.RGBA_52,
      margin: theme.spacing(2, 1, 1),
    },
    billRef: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
      alignItems: "center",
      padding: theme.spacing(2, 2, 1),
    },
    cardHeader: {
      display: "flex",
      background: theme.palette.secondary.main,
      padding: theme.spacing(1, 2),
      marginBottom: theme.spacing(2),
    },
    cardHeaderEmpty: {
      minHeight: theme.spacing(2),
    },
    cardMainTitle: {
      color: theme.palette.text.primary,
      typography: theme.typography.body2_semibold,
      width: "100%",
    },
    cardAmountValue: {
      color: theme.palette.warning.main,
      fontSize: size.TITLE_FONTSIZE,
      fontWeight: theme.typography.fontWeightMedium,
      width: "100%",
      textAlign: "right",
    },
    cardDetailWrapper: {
      padding: 0,
      "&:last-child": {
        borderBottom: `1px solid ${theme.palette.secondary.light}`,
        paddingBottom: theme.spacing(2),
        marginBottom: theme.spacing(1),
      },
      "&:first-child": {
        paddingTop: theme.spacing(2),
      },
    },
    cardHeadDetails: {
      minHeight: "100%",
      wordBreak: "break-word",
      margin: theme.spacing(0, 2, 0),
      display: "flex",
      paddingBottom: theme.spacing(0.5),
      alignItems: "center",
    },
    cardDetails: {
      minHeight: "100%",
      wordBreak: "break-word",
      padding: theme.spacing(0, 2),
      display: "flex",
      alignItems: "center",
    },
    cardHeadLeft: {
      width: "35%",
    },
    cardLeft: {
      width: "50%",
    },
    cardHeadRight: {
      textAlign: "right",
      color: theme.palette.common.black,
      typography: theme.typography.body2_semibold,
      width: "65%",
    },
    cardRight: {
      textAlign: "right",
      color: theme.palette.common.black,
      typography: theme.typography.body2_semibold,
      width: "50%",
    },
    cardTitle: {
      color: theme.palette.text.primary,
      typography: theme.typography.body2_semibold,
      padding: theme.spacing(0.75, 0, 0),
    },
    cardSubTitle: {
      color: theme.palette.grey[600],
      typography: theme.typography.caption1_semibold,
      paddingBottom: theme.spacing(0.75),
    },
    cardLabel: {
      color: theme.palette.grey[600],
      typography: theme.typography.caption1_semibold,
      padding: theme.spacing(0.75, 0, 0),
    },
    billRefLabel: {
      color: theme.palette.grey[600],
      typography: theme.typography.body2_regular,
    },
    billRefNumber: {
      color: theme.palette.grey[400],
      typography: theme.typography.body2_semibold,
    },
    cardDate: {
      color: theme.palette.warning.main,
      typography: theme.typography.body2_semibold,
    },
    cardValue: {
      color: theme.palette.grey[600],
      typography: theme.typography.body2_semibold,
      padding: theme.spacing(0.75, 0, 0),
      "& img": {
        padding: theme.spacing(0.75, 0, 0),
      },
    },
    cardAmount: {
      color: theme.palette.common.black,
      typography: theme.typography.body2_semibold,
      marginTop: theme.spacing(1),
    },
    cardFooter: {
      minHeight: "100%",
      wordBreak: "break-word",
      padding: theme.spacing(0.75, 2, 2),
      display: "flex",
      borderTop: "1px solid " + theme.palette.grey[100],
      marginTop: theme.spacing(1),
      alignItems: "center",
    },
    noticePanel: {
      marginTop: theme.spacing(-2),
    },
    cardButtons: {
      padding: theme.spacing(2.5, 1),

      "& :hover": {
        backgroundColor: theme.palette.primary.main,
      },
    },
    fullButton: {
      display: "block",
      width: "100%",
      mt: 2,
    },
    cardValueBox: {
      color: theme.palette.warning.main,
      fontSize: size.TITLE_FONTSIZE,
      fontWeight: theme.typography.fontWeightMedium,
      display: "flex",
      alignItems: "center",
      width: "150px",
      marginTop: theme.spacing(1),
      float: "right",
      "& .MuiOutlinedInput-root": {
        borderRadius: theme.spacing(0.5),
        marginLeft: theme.spacing(0.5),
      },
      "& .MuiOutlinedInput-input": {
        color: theme.palette.warning.main,
        fontSize: size.TITLE_FONTSIZE,
        fontWeight: theme.typography.fontWeightMedium,
        textAlign: "right",
      },
      "& div ": {
        "& div:nth-child(2)": {
          position: "absolute",
          right: theme.spacing(1),
        },
      },
    },
  } satisfies SxObjType;
};

export { sxStyles };
